// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@tps/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { reviewBudgetStyles } from "@tps/Overrides/Widgets/Budget/ReviewBudget";
import { mergeWithCss, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

reviewBudgetStyles.filterWrapper = {
    css: css`
        padding: 8px 0 8px;
    `,
};

reviewBudgetStyles.titleText = {
    as: "h2",
    variant: "h4",
    css: css`
        margin: 0;
        padding: 0 0 9px;
    `,
};

reviewBudgetStyles.wrapper = {
    css: css`
        display: inline-block;
        margin: 0 30px 22px 0;
        ${xScreen("lte", "sm")} {
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

reviewBudgetStyles.enforcementLevelDisplayStyles = {
    wrapper: {
        css: css`
            padding: 10px 0;
            gap: 5px;
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                padding: 11px 0 8px;
            }
        `,
    },
};

reviewBudgetStyles.noResultsText = {
    ...mergeWithCss(dataTableStyles.noResultsText, {
        as: "h3",
        variant: "h6",
    }),
};

reviewBudgetStyles.centeringWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

reviewBudgetStyles.spinner = {
    css: css`
        height: 150px;
        margin: auto;
    `,
};
